import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(Tooltip);


import LandingPage from './views/LandingPage.vue';
import ResultsPage from './views/ResultsPage.vue';

const routes = [
  { path: '/', component: LandingPage },
  { path: '/results', component: ResultsPage },
]

const router = new VueRouter({
  routes
})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
